$(document).ready(function () {
    // Default selection: SCIENCE
    const defaultType = "SCIENCE";

    // Set default active state and show corresponding modules
    $(`.steam-card[data-steamtype="${defaultType}"]`).addClass("active");
    $(".module-card").hide();
    $(`.module-card[data-steamtype="${defaultType}"]`).show();

    // On click: filter modules based on selected steam card
    $(".steam-card").on("click", function () {
        const selectedType = $(this).data("steamtype");

        // Highlight selected card
        $(".steam-card").removeClass("active");
        $(this).addClass("active");

        // Filter module cards
        $(".module-card").hide();
        $(`.module-card[data-steamtype="${selectedType}"]`).fadeIn();
    });
});
